import { Button } from 'devextreme-react';
import { FileUploader } from 'devextreme-react/file-uploader';
import { Form } from 'devextreme-react/form';
import React, { useRef, useState } from 'react';
import { Col, Row } from 'reactstrap';

const DamageReportForm = ({ onClose, onSubmit, default_sase, sase_disabled }) => {
    const formRef = useRef(null);
    const [formData, setFormData] = useState({
        damage_date: new Date(),
        chassis_no: default_sase ? default_sase : '',
        damage_region: '',
        reporter_name: localStorage.getItem("fullName"),
        responsible: '',
        description: '',
        image: null
    });

    const formItems = {
        items: [{
            itemType: 'group',
            colCount: 2,
            items: [{
                dataField: 'damage_date',
                editorType: 'dxDateBox',
                editorOptions: {
                    type: 'datetime',
                    displayFormat: 'dd/MM/yyyy HH:mm',
                },
                validationRules: [{
                    type: 'required',
                    message: 'Tarih zorunludur'
                }]
            },
            {
                dataField: 'chassis_no',
                label: {
                    text: 'Şase No'
                },
                editorOptions: {
                    maxLength: 17,
                    disabled: sase_disabled ? true : false
                },
                validationRules: [{
                    type: 'required',
                    message: 'Şase no zorunludur'
                }, {
                    type: 'stringLength',
                    min: 17,
                    max: 17,
                    message: 'Şase no 17 karakter olmalıdır'
                }]
            }, {
                dataField: 'damage_region',
                label: {
                    text: 'Bölge'
                },
                validationRules: [{
                    type: 'required',
                    message: 'Bölge zorunludur'
                }]
            }, {
                dataField: 'reporter_name',
                editorOptions: {
                    disabled: true
                },
                label: {
                    text: 'Bildiren Kişi'
                },
                validationRules: [{
                    type: 'required',
                    message: 'Bildiren kişi zorunludur'
                }]
            }, {
                dataField: 'responsible',
                label: {
                    text: 'Hasar Sorumlusu'
                }
            }]
        }, {
            itemType: 'group',
            colCount: 1,
            items: [{
                dataField: 'description',
                editorType: 'dxTextArea',
                editorOptions: {
                    height: 100
                },
                label: {
                    text: 'Hasar Açıklaması'
                },
                validationRules: [{
                    type: 'required',
                    message: 'Açıklama zorunludur'
                }]
            }]
        }]
    };

    const handleSubmit = async (e) => {
        // e.preventDefault();

        const result = formRef.current.instance.validate();
        console.log(formData);
        //  if (result.complete) {
        if (result.isValid) {
            onSubmit(formData);
        }
        //}
    };

    const handleFieldDataChanged = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.dataField]: e.value
        }));
    };

    return (
        <div className="p-3">
            {/* <h5 className="text-center mb-4">Hasar Bildirimi Ekle</h5> */}
            {/* <hr /> */}
            <Form
                ref={formRef}
                formData={formData}
                items={formItems.items}
                onFieldDataChanged={handleFieldDataChanged}
                showValidationSummary={true}
                validationGroup="damageForm"
            />

            <Row className="mt-4">
                <Col xs={12}>
                    <FileUploader
                        selectButtonText="Görsel Seç"
                        labelText="veya sürükle bırak"
                        accept="image/*"
                        uploadMode="useForm"
                        onValueChanged={(e) => {
                            setFormData(prev => ({
                                ...prev,
                                image: e.value[0]
                            }));
                        }}
                    />
                </Col>
            </Row>

            <Row className="mt-4">
                <Col className="d-flex justify-content-end"
                    style={{
                        gap: '10px'
                    }}>
                    <Button
                        text="İptal"
                        onClick={onClose}
                        stylingMode="outlined"
                    />
                    <Button
                        text="Kaydet"
                        type="default"
                        onClick={handleSubmit}
                        stylingMode="contained"
                        useSubmitBehavior={true}
                        validationGroup="damageForm"
                    />
                </Col>
            </Row>
        </div>
    );
};

export default DamageReportForm;